export enum Role {
  Employee = "Employee",
  Admin = "Admin",
  LocationAdmin = "Location Admin",
  BusinessAdmin = "Business Admin",
  Orbital = "Orbital",
}
